import { DialogBody, Separator, Spinner, Stack, Table } from "@chakra-ui/react";
import { Parts, UI } from "components";
import useNetworkSearch from "hooks/useNetworkSearch";
import { useState } from "react";

export default function Search({ ...props }){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const search = useNetworkSearch(page, term)
    const [ downline, setDownline ] = useState(false)

    return(
    <>
    <Parts.Dialog.Network.Downline open={!!downline} data={{...downline, id: downline?.consultant_id}} onClose={() => setDownline(false)} />
    <UI.Dialog title="Procurar consultor na rede" {...props}>
        <DialogBody>
            <Stack gap={4}>
                <UI.Alert size="sm">O mapeamento de rede é um trabalho demorado e constante. Portanto, novos consultores podem levar algumas horas para aparecer em sua rede.</UI.Alert>
            
                <Separator />

                <UI.Searchable placeholder="Procurar pelo nome, email ou CPF..." value={term} onChange={setTerm} isDisabled={search.isFetching} />

                <UI.Show visible={search.isFetching}><UI.Alert size="sm" indicator={<Spinner />}>Buscando consultores...</UI.Alert></UI.Show>

                <UI.Table columns={[{ children: 'Consultor' }, { children: 'Nível' }]} data={search.data} Row={Row} RowProps={{ setDownline }} />

            </Stack>
        </DialogBody>
    </UI.Dialog>
    </>
    )
}

const Row = ({ data, setDownline = () => {} }) => {
    return(
    <Table.Row cursor="pointer" onClick={() => setDownline(data)}>
        <Table.Cell textTransform="capitalize">{data?.name}</Table.Cell>
        <Table.Cell>{data?.level}</Table.Cell>
    </Table.Row>
    )
}